export const inv01_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-01-2026/BASES CAASIM-HGO-INV3-OP-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-01-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-01-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-01-2026/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-01-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-01-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // Do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-01-2026/Presentación y apertura CAASIM-HGO-INV3-OP-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-01-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-01-2025/FALLO CAASIM-HGO-INV3-01-2025.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const inv02_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-02-2026/BASES CAASIM-HGO-INV3-OP-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-02-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-02-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-02-2026/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-02-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-02-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // Do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-02-2026/Presentación y apertura CAASIM-HGO-INV3-OP-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-02-2026/Fallo CAASIM-HGO-INV3-OP-02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv03_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/BASES CAASIM-HGO-INV3-OP-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-03-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-03-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-03-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Presentación y apertura CAASIM-HGO-INV3-OP-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv04_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-04-2026/BASES CAASIM-HGO-INV3-OP-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-04-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-04-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-04-2026/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-04-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-04-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-04-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-04-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const inv05_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-05-2026/BASES CAASIM-HGO-INV3-OP-05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-05-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-05-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-05-2026/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-05-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-05-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-05-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-05-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-05-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-05-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const inv06_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-06-2026/BASES CAASIM-HGO-INV3-OP-06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-06-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-06-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-06-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-06-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-06-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-06-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-06-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-06-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-06-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const inv07_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-07-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-07-2026/BASES CAASIM-HGO-INV3-OP-07-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-07-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-07-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-07-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-07-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-07-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-07-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-07-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-07-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-07-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-07-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-07-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-07-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-07-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-07-2026/Fallo CAASIM-HGO-INV3-OP-07-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv08_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-08-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-08-2026/BASES CAASIM-HGO-INV3-OP-08-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-08-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-08-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-08-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-08-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-08-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-08-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-08-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-08-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-08-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-08-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-08-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-08-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-08-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-08-2026/Fallo CAASIM-HGO-INV3-OP-08-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv09_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-09-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-09-2026/BASES CAASIM-HGO-INV3-OP-09-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-09-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-09-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-09-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-09-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-09-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-09-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-09-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-09-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-09-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-09-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-09-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const inv10_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-10-2026/BASES CAASIM-HGO-INV3-OP-10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-10-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-10-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-10-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-10-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-10-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-10-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-10-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const inv11_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-11-2026/BASES CAASIM-HGO-INV3-OP-11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-11-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-11-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-11-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-11-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-11-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-11-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-11-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-11-2026/Fallo CAASIM-HGO-INV3-OP-11-2026.pdf",
            // word: "www.google.com11
          },
        ],
      },
    ],
  },
];
export const inv12_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-12-2026/BASES CAASIM-HGO-INV3-OP-12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-12-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-12-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-12-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-12-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-12-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-12-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-12-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-12-2026/Fallo CAASIM-HGO-INV3-OP-12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv13_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-13-2026/BASES CAASIM-HGO-INV3-OP-13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-13-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-13-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-13-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-13-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-13-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-13-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-13-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-13-2026/Fallo CAASIM-HGO-INV3-OP-13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv14_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-14-2026/BASES CAASIM-HGO-INV3-OP-14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-14-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-14-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-14-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-14-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-14-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-14-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-14-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-14-2026/Fallo CAASIM-HGO-INV3-OP-14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv15_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-15-2026/BASES CAASIM-HGO-INV3-OP-15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-15-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-15-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-15-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-15-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-15-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-15-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-15-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-15-2026/Fallo CAASIM-HGO-INV3-OP-15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv16_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-16-2026/BASES CAASIM-HGO-INV3-OP-16-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-16-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-16-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-16-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-16-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-16-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-16-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-16-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-16-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-16-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-16-2026/Fallo CAASIM-HGO-INV3-OP-16-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const inv17_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-17-2026/BASES CAASIM-HGO-INV3-OP-17-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-17-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-17-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-17-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-17-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-17-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-17-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-17-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-17-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-17-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const inv18_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-18-2026/BASES CAASIM-HGO-INV3-OP-18-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-18-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-18-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-18-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-18-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-18-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-18-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-18-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-18-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-18-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const inv19_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-19-2026/BASES CAASIM-HGO-INV3-OP-19-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-19-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-19-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-19-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-19-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-19-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-19-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-19-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-19-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-19-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2026",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-03-2026/Fallo CAASIM-HGO-INV3-OP-03-2026.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const inv20_2026 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-20-2026/BASES CAASIM-HGO-INV3-OP-20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-20-2026/CATALOGO MUDO CAASIM-HGO-INV3-OP-20-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-20-2026/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-20-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-20-2026/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-20-2026.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-20-2026/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-20-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/CAASIM-HGO-INV3-OP-20-2026/Fallo CAASIM-HGO-INV3-OP-20-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv_itp_01 = [
  {
    nombre: "BASES ITP-CAASIM-SRMySG-SAL-01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2026/ITP-CAASIM-SRMySG-SAL-01-2026/BASES ITP-CAASIM-SRMySG-SAL-01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
